function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
}

function getCookie(name) {
    const cArr = document.cookie.split(';')
    for (let i = 0; i < cArr.length; i++) {
        const cookie = cArr[i].split('=', 2)
        cookie[0] = cookie[0].replace(/^\s+/, '')
        if (cookie[0] == name) {
            return cookie
        }
    }
}

function setCookie(name, value, days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = '; expires=' + date.toGMTString()
    document.cookie = name + '=' + value + expires + '; path=/'
}

window.addEventListener("load", () => {
    utm_source = getURLParameter("utm_source");
    utm_medium = getURLParameter("utm_medium");
    utm_campaign = getURLParameter("utm_campaign")
    utm_community = getURLParameter("utm_community");
    utm_home_type = getURLParameter("utm_home_type");

    console.log(utm_community)
    // Set Cookie values
    if (utm_source || utm_medium || utm_campaign || utm_community || utm_home_type ) {
        dict = {}
        dict.utm_source = utm_source
        dict.utm_medium = utm_medium
        dict.utm_campaign = utm_campaign
        dict.utm_community = utm_community
        dict.utm_home_type = utm_home_type
        setCookie("utm_params", JSON.stringify(dict), 365)
        console.log('set cookie')
    }

    // Get cookie values and add to hidden form fields
    let utm_params = getCookie("utm_params")
    if (utm_params !== null && utm_params !== undefined) {
        params = JSON.parse(utm_params[1]) // Convert from string to dict
        document.querySelectorAll(".utm_source").forEach(element => {
            element.value = params.utm_source
        });
        document.querySelectorAll(".utm_medium").forEach(element => {
            element.value = params.utm_medium
        });
        document.querySelectorAll(".utm_campaign").forEach(element => {
            element.value = params.utm_campaign
        });
        document.querySelectorAll(".utm_community").forEach(element => {
            element.value = params.utm_community
        });
        document.querySelectorAll(".utm_home_type").forEach(element => {
            element.value = params.utm_home_type
        });
    }
})
